import axios from "axios";
import { jwtDecode } from "jwt-decode";

const isExpiredToken = (token) => {
  if (!token) return false;

  try {
    return jwtDecode(token).exp < Date.now() / 1000;
  } catch {
    return true;
  }
};

const refreshAccessToken = async (refreshCallback) => {
  if (typeof refreshCallback !== "function") {
    throw new Error("refreshCallback is not a function");
  }

  const refreshed = await refreshCallback();
  if (!refreshed) {
    throw new Error("Unable to refresh access token");
  }

  const accessToken = localStorage.getItem("accessToken");
  if (!accessToken) {
    throw new Error("Unable to refresh access token");
  }

  return accessToken;
};

const secureFetch = async (url, options = {}, refreshCallback) => {
  let accessToken = localStorage.getItem("accessToken");

  // Check if the access token is expired
  if (isExpiredToken(accessToken)) {
    accessToken = await refreshAccessToken(refreshCallback);
  }

  // Set the authorization header
  options.headers = { ...options.headers };
  if (accessToken) {
    options.headers.Authorization = `Bearer ${accessToken}`;
  }

  // Use Axios to make the request
  try {
    const response = await axios({
      url,
      ...options,
      withCredentials: true,
    });
    return response;
  } catch (error) {
    const shouldRefresh =
      error.response &&
      [401, 403].includes(error.response.status) &&
      (accessToken || localStorage.getItem("refreshToken"));

    if (shouldRefresh) {
      accessToken = await refreshAccessToken(refreshCallback);
      options.headers.Authorization = `Bearer ${accessToken}`;
      const retryResponse = await axios({
        url,
        ...options,
        withCredentials: true,
      });
      return retryResponse;
    }
    throw error;
  }
};

export default secureFetch;
